/**
 * Legal / consent contract (#126, FR-13.1/FR-13.2).
 *
 * The single source of truth for the **policy version** shared by the server (which
 * stamps it onto the player record on consent) and the web client (which sends the
 * version it displayed). Kept here in `@jeopardy/shared` so the two sides can never
 * drift — mirroring how the wire contract lives here (AGENT_GUIDE rule 2).
 *
 * This is a control-plane concern, NOT the game WS protocol — it does not affect
 * {@link PROTOCOL_VERSION}. The accepted version is persisted on the player record
 * ({@link PlayerRecord.tosAcceptedVersion}) and is control-plane / self-view only; it
 * never goes on the game wire.
 *
 * **Bump this whenever the substance of the Terms / Privacy / Refund copy changes** so a
 * previously-consented player is re-prompted for the new text. It is a plain, opaque
 * string (a date stamp by convention); consumers compare it for equality only.
 */
export const POLICY_VERSION = '2026-08-26';
